import { Card, CardBody, CardHeader } from "reactstrap";
import { FilterButtonGroup } from "../../toc/FilterButtonGroup";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  title: string;
  icon?: IconDefinition;
  all: string[];
  selected: string[];
  setSelected: (value: ((prevState: string[]) => string[]) | string[]) => void;
  valueToLabelMapper?: (value: string) => string;
  dataCy?: string;
}

export function FilterCard({
  title,
  icon,
  all,
  selected,
  setSelected,
  valueToLabelMapper,
  dataCy,
}: Props) {
  return (
    <Card data-cy={dataCy}>
      <CardHeader>
        {icon && <FontAwesomeIcon icon={icon} />} {title}
      </CardHeader>
      <CardBody>
        <FilterButtonGroup
          values={all}
          selectedValues={selected}
          selectedValuesSetter={setSelected}
          valueToLabelMapper={valueToLabelMapper}
        />
      </CardBody>
    </Card>
  );
}
